import { DataSource, Layout, Switch, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutTrackingHistory extends Layout {
    sourceEquipmentPositionsAndCallins: DataSource;
    switchPositionCallin: Switch;
    tabCallins: Tab;
    tabCommMessages: Tab;
    tabPositions: Tab;
    tableCallins: Table;
    tableCommMessages: Table;
    tablePositions: Table;
    tabsetTractorHistory: Tabset;
}
